import { render, staticRenderFns } from "./HistoricoProveedor.vue?vue&type=template&id=79edd9f4"
import script from "./HistoricoProveedor.vue?vue&type=script&lang=js"
export * from "./HistoricoProveedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports